module.exports = __webpack_public_path__ + "img/Tutorial-thumbdnail.3c142b02.png";